import { createFileRoute } from '@tanstack/react-router';
import { CountsPage } from '@/features/inventory/pages/count-pages';

export const Route = createFileRoute('/_app/inventory/count/')({ component: CountsPage });
